var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.47a.75.75 0 0 1 .75.75V18c0 .987.136 1.481.377 1.756.219.25.688.494 1.873.494h9c1.185 0 1.654-.244 1.873-.494.24-.275.377-.769.377-1.756V9.22a.75.75 0 0 1 1.5 0V18c0 1.014-.114 2.02-.748 2.744-.656.75-1.687 1.006-3.002 1.006h-9c-1.315 0-2.346-.256-3.002-1.006-.634-.725-.748-1.73-.748-2.744V9.22a.75.75 0 0 1 .75-.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.28 2.28c-.31.31-.53.836-.53 1.72v2c0 .884.22 1.41.53 1.72.31.31.836.53 1.72.53h14c.884 0 1.41-.22 1.72-.53.31-.31.53-.836.53-1.72V4c0-.884-.22-1.41-.53-1.72-.31-.31-.836-.53-1.72-.53H4c-.884 0-1.41.22-1.72.53ZM1.22 1.22C1.91.53 2.884.25 4 .25h14c1.116 0 2.09.28 2.78.97s.97 1.664.97 2.78v2c0 1.116-.28 2.09-.97 2.78s-1.664.97-2.78.97H4c-1.116 0-2.09-.28-2.78-.97S.25 7.116.25 6V4c0-1.116.28-2.09.97-2.78ZM8.43 13a.75.75 0 0 1 .75-.75h3.64a.75.75 0 0 1 0 1.5H9.18a.75.75 0 0 1-.75-.75Z",
    fill: "currentColor"
  })));
};
export default SvgArchive;